<template>
  <div>
    <mail-service-header></mail-service-header>
    <account></account>
  </div>
</template>

<script>
import MailServiceHeader from './screens/Layout/components/MailServiceHeader';
import Account from './screens/Account/components/List';

export default {
  components: {
    MailServiceHeader,
    Account,
  },
};
</script>



// WEBPACK FOOTER //
// Index.vue?701140e7